import { registerModule } from '../registerModule';

export default function registerStoreModule(_, { name, module }) {
	registerModule(name, module);
}
